import axios from "axios";
import { config } from "../helpers/config";

export const ADMIN_TOKEN_KEY = "storakAdminToken";

const adminApi = axios.create({
  baseURL: config.storakAuthApiUrl,
});

adminApi.interceptors.request.use((request) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

// An expired operator token should drop straight back to the login form rather
// than leaving the console showing stale data.
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(ADMIN_TOKEN_KEY);

      if (!window.location.pathname.startsWith("/admin/login")) {
        window.location.replace("/admin/login");
      }
    }

    return Promise.reject(error);
  }
);

export default adminApi;
